import { css } from '@emotion/css';
import { Theme } from '@mui/material';

import { HEADER_HEIGHT } from '../chromeSizes';

const useAuthenticatedLayoutStyles = (theme: Theme) => {
  const isDarkTheme = theme.palette.mode === 'dark';

  return {
    pageWrapper: css({
      display: 'flex',
      flex: 1,
      minHeight: 0,
      paddingTop: HEADER_HEIGHT,
      backgroundColor: isDarkTheme ? theme.palette.background.default : '#f0f4fa',
    }),
    sidebar: css({
      width: 240,
      padding: theme.spacing(4, 3),
      backgroundColor: isDarkTheme ? theme.palette.background.paper : '#0f3658',
      color: '#ffffff',
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
      position: 'sticky',
      top: HEADER_HEIGHT,
      alignSelf: 'flex-start',
      minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    }),
    sidebarTitle: css({
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: isDarkTheme ? theme.palette.primary.light : '#8ff0d3',
    }),
    navList: css({
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
      padding: 0,
    }),
    navItem: css({
      borderRadius: Number(theme.shape.borderRadius) * 1.5,
      color: 'rgba(255,255,255,0.8)',
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.08)',
      },
    }),
    navItemActive: css({
      borderRadius: Number(theme.shape.borderRadius) * 1.5,
      backgroundColor: 'rgba(143, 240, 211, 0.18)',
      color: '#ffffff',
      borderLeft: '4px solid #8ff0d3',
      '&:hover': {
        backgroundColor: 'rgba(143, 240, 211, 0.28)',
      },
      '& .MuiListItemIcon-root': {
        color: '#8ff0d3',
      },
    }),
    navIcon: css({
      color: 'inherit',
      minWidth: 32,
    }),
    logoutButton: css({
      marginTop: 'auto',
      color: 'rgba(255,255,255,0.85)',
      justifyContent: 'flex-start',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.08)',
      },
    }),
    container: css({
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      // HA-481: a flex item won't shrink below its content otherwise, and one wide child widens the whole page.
      minWidth: 0,
      padding: theme.spacing(6, 4, 8),
      backgroundColor: isDarkTheme ? theme.palette.background.default : '#f5f7fb',
      color: theme.palette.text.primary,
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(3, 2, 12),
      },
    }),
    mobileHeader: css({
      display: 'none',
      [theme.breakpoints.down('md')]: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    }),
    menuButton: css({
      minWidth: 44,
      minHeight: 44,
      padding: theme.spacing(1),
      borderRadius: Number(theme.shape.borderRadius) * 1.5,
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: isDarkTheme ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
      },
    }),
    mobilePageTitle: css({
      fontWeight: 700,
      fontSize: '1.25rem',
      letterSpacing: '-0.02em',
      flex: 1,
    }),
  };
};

export default useAuthenticatedLayoutStyles;
